
<template>
    <a class="py-4 px-6 w-full font-fauli rounded-lg country-button shadow-md"
       :class="buttonClass"
       :href="href"
       @click.prevent="$emit('click')">
        <span class="button-content">
            <img v-if="flagUrl"
                 :src="flagUrl"
                 :alt="`${countryName} flag`"
                 class="object-contain mr-15 w-[48px] h-[28px]">
            {{ countryName }}
        </span>
        <img v-if="uniquemanUrl"
             :src="uniquemanUrl"
             :alt="`${countryName} uniqueman`"
             class="uniqueman-image">
    </a>
</template>

<script lang="ts">
import { defineComponent } from 'vue';

export default defineComponent({
    name: 'CountryButton',
    props: {
        countryName: {
            type: String,
            required: true,
        },
        flagUrl: {
            type: String,
            default: null,
        },
        uniquemanUrl: {
            type: String,
            default: null,
        },
        buttonClass: {
            type: String,
            default: 'bg-red-600',
        },
        href: {
            type: String,
            default: '#',
        },
    },
    emits: ['click'],
});
</script>

<style scoped>
    .country-button {
        background-image: url('@/assets/images/country-button-bg.svg');
        background-size: contain;
        background-repeat: no-repeat;
        background-position: center;
        display: flex;
        align-items: center;
        justify-content: flex-start;
        position: relative;
        overflow: visible;
    }

    .button-content {
        display: flex;
        align-items: center;
        justify-content: flex-start;
        text-align: left;
        margin-left: 20px;
    }

    .uniqueman-image {
        position: absolute;
        right: 15px;
        bottom: 5px;
        height: 107px;
        width: 88px;
        object-fit: contain;
        pointer-events: none;
        transform: scaleX(-1);
    }

    @media (max-width: 767px) {
        .country-button {
            width: 100%;
            box-sizing: border-box;
        }
        
        .uniqueman-image {
            bottom: 6px;
        }
    }
</style>
